<template>
	<DsHcMultipleChoice
		:name="state.currentQuestion.questionBlockId"
		:legend="state.currentQuestion.questionText"
		:description="state.currentQuestion.subText"
		:options="options"
		:validationMessage="state.currentQuestion.validationMessageText"
		:invalid="state.currentQuestion.isTouched && !state.currentQuestion.isValid"
		:columns="columns"
		:modelValue="state.answersByQuestionId[state.currentQuestion.questionBlockId]?.map(answer => answer.value)"
		@change="setAnswer"
	></DsHcMultipleChoice>
</template>

<script setup>
import { DsHcMultipleChoice } from '@coloplast/design-system';
import { useHealthCheckState } from '../useHealthCheckState';

const { state } = useHealthCheckState();
const emit = defineEmits(['setAnswer']);

const setAnswer = (response) => {
	emit('setAnswer', { 
		questionBlockId: state.currentQuestion.questionBlockId,
		answer: response.map(value => state.currentQuestion.options.find(option => option.value === value)) 
	});
};

const columns = state.currentQuestion.options.some(option => option.image) ? 2 : 1;

const options = state.currentQuestion.options.map((option) => ({
	id: option.answerBlockId,
	label: option.text,
	value: option.value,
	imageSrc: option.image,
	helper: option.tooltipLinkText ? {
		text: option.tooltipLinkText,
		...(option.tooltip && {
			toggletip: {
				buttonLabel: option.tooltipButtonText ?? option.tooltipLinkText,
				text: option.tooltip,
			},
		}),
	} : null,
}));
</script>